import axios from 'axios';
import clone from 'lodash/clone';
import each from 'lodash/each';
import cloneDeep from 'lodash/cloneDeep';

import config from 'config';
import {PaginatableCollection} from 'domains/base/collections';

export default {
    state: {
        printers: new PaginatableCollection(),
        currentPrinter: {
            products: new PaginatableCollection(),
        },
        currentPrinterProduct: null,
    },
    actions: {
        async getPrinters({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.printers.search}?page=${rootState.route.params.page ? rootState.route.params.page - 1 : 0}`);

            let printers = clone(response.data);

            each(printers._embedded.items, printer => {
                printer.loading = false;
                printer.editing = false;
            });

            commit('setPaginatableCollection', {paginatableCollection: state.printers, data: printers});

            return response;
        },
        async getPrinter({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.printers.get.replace('{printerId}', rootState.route.params.id)}`);

            commit('updateState', {state, property: 'currentPrinter', value: response.data});

            commit('updateState', {
                state: state.currentPrinter,
                property: 'products',
                value: new PaginatableCollection()
            });

            return response;
        },
        async updatePrinter({state}, printer) {
            return axios.put(printer._links.update_printer, {
                active: printer.active,
                name: printer.name,
                fulfillment_price: parseFloat(printer.fulfillment_fee),
                ideal_maximum_daily_volume: parseInt(printer.ideal_maximum_daily_volume),
            });
        },
        async activatePrinter({dispatch}, printer) {
            let response = await axios.patch(printer._links.activate);

            dispatch('getPrinters');

            return response;
        },
        async deactivatePrinter({dispatch}, printer) {
            let response = await axios.patch(printer._links.deactivate);

            dispatch('getPrinters');

            return response;
        },
        async getPrinterProducts({state, commit}, page) {
            let response = await axios.get(`${state.currentPrinter._links.products}?page=${page ? page - 1 : 0}`);

            commit('setPaginatableCollection', {
                paginatableCollection: state.currentPrinter.products,
                data: response.data
            });

            return response;
        },
        async getPrinterProduct({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.printer_products.get.replace('{printerId}', rootState.route.params.printerId).replace('{printerProductId}', rootState.route.params.id)}`);

            response.data.product._links = response.data._links;

            commit('updateState', {state, property: 'currentPrinterProduct', value: response.data.product});

            return response;
        },
        async removePrinterProduct({dispatch}, {product, page}) {
            let response = await axios.delete(product._links.delete);

            response = await dispatch('getPrinter');

            response = await dispatch('getPrinterProducts', page);

            return response;
        },
        updatePrinterProduct({state, commit}) {
            let payload = cloneDeep(state.currentPrinterProduct);

            delete payload._links;

            delete payload.product;

            payload.color_overrides = [];

            each(payload.colors, color => {
                if (color.printer_specific_color_name) {
                    payload.color_overrides.push({product_color_id: color.id, name: color.printer_specific_color_name});
                }
            });

            delete payload.colors;

            return axios.put(state.currentPrinterProduct._links.update_product, payload);
        },
    },
    mutations: {},
};
